import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-statistical",
  "use": "icon-statistical-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-statistical\"><defs><style type=\"text/css\"></style></defs><path d=\"M122.88 534.186667h163.84v356.266666H122.88V534.186667z m245.76-445.184h163.84v801.450666H368.64V89.002667zM614.4 267.093333h163.84v623.36H614.4V267.093333zM860.16 0H1024v890.453333h-163.84V0zM81.92 934.997333H1024V1024H0V0h81.92v934.997333z\" p-id=\"1994\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/statistical.svg
// module id = 3pKd
// module chunks = 77